import { render, staticRenderFns } from "./AddCmsComponent.vue?vue&type=template&id=e1837c08"
import script from "./AddCmsComponent.vue?vue&type=script&lang=js"
export * from "./AddCmsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports